import request from '@/util/request';
import qs from 'qs';
export const getsupplierList = (params, options) =>
request.get('/api/v4ward/partner/supplierList', Object.assign({}, options, { params }));
export const getList = (params, options) =>
request.get('/api/v4ward/engineering/page', Object.assign({}, options, { params }));
export const getChargeMan = (params, options) =>
request.get('/api/v4ward/engineering/getWorkChargeName', Object.assign({}, options, { params }));
export const getDetail = (params, options) =>
request.get('/api/v4ward/engineering/detail', Object.assign({}, options, { params }))

export const remove = (ids) =>
request.post('/api/v4ward/engineering/remove?ids='+ids);

export const add = (params, options) =>
request.post('/api/v4ward/engineering/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/engineering/update', params,options)

export const editPlan = (params, options) =>
request.post('/api/v4ward/engineering_plan/update', params,options)

export const getEditPlan = (params, options) =>
request.get('/api/v4ward/engineering_plan/detail', Object.assign({}, options, { params }))
